(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wewo-campaign-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wewo-campaign-ticker')) {
    customElements.define('wewo-campaign-ticker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
          button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wewo-motion-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wewo-motion-banner')) {
    customElements.define('wewo-motion-banner', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = Array.from(this.querySelector('.wewo-motion__slides').children);
        this.dots = Array.from(this.querySelectorAll('[data-motion-index]'));
        this.toggle = this.querySelector('[data-motion-pause]');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motionQuery.matches;
        this.index = 0;
        this.visible = true;
        this.hovered = false;
        this.focused = false;
        this.slides.forEach((slide, i) => { slide.inert = i !== 0; });
        this.querySelectorAll('[data-motion-step]').forEach(button => button.addEventListener('click', () => this.show(this.index + Number(button.dataset.motionStep)), options));
        this.dots.forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.motionIndex)), options));
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); } }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motionQuery.addEventListener('change', event => { this.paused = event.matches; this.updatePause(); this.schedule(); }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.updatePause();
        requestAnimationFrame(() => { if (this.isConnected) this.setAttribute('data-motion-ready', ''); });
        this.schedule();
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
      updatePause() {
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
        this.toggleAttribute('data-motion-paused', this.paused);
        this.querySelectorAll('.slide__image').forEach(image => image.getAnimations().forEach(animation => {
          if (this.paused && animation.playState === 'running') animation.pause();
          else if (!this.paused && animation.playState === 'paused') animation.play();
        }));
      }
      async show(value) {
        const next = (value + this.slides.length) % this.slides.length;
        if (next === this.index || this.busy) return;
        this.busy = true;
        clearTimeout(this.timer);
        const images = Array.from(this.slides[next].querySelectorAll('img'));
        await Promise.all(images.map(image => { image.loading = 'eager'; return image.decode().catch(() => {}); }));
        if (!this.isConnected) { this.busy = false; return; }
        this.slides.forEach((slide, i) => { slide.setAttribute('aria-hidden', String(i !== next)); slide.inert = i !== next; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === next)));
        this.index = next;
        this.busy = false;
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || this.focused || !this.visible || document.hidden || this.slides.length < 2) return;
        this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.delay));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
